import React from "react";
import { Link } from "react-router-dom";
import "./styles.scss";

export default class ArrowLink extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    const style = this.props.style;
    return (
      <span className={`arrowLink ${style}`} onClick={this.handleOnClick}>
        {this.props.href ? (
          <Link to={this.props.href}>{this.props.children}</Link>
        ) : (
          <span>{this.props.children}</span>
        )}
      </span>
    );
  }
}
